import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { admins } from "../../Constants";

const tiles: { to: string; title: string; desc: string }[] = [
    { to: "/admin/users", title: "Users", desc: "All accounts with donator / beta / premium / admin flags" },
    { to: "/admin/donators", title: "Donators", desc: "Add & edit donations — amounts, history, donator status" },
    { to: "/admin/uploaded-demos", title: "Uploaded Demos", desc: "Every user demo upload, grouped by uploader" },
    { to: "/admin/banner", title: "Site Banner", desc: "Edit the site-wide banner message" },
    { to: "/admin/tournaments", title: "Tournaments", desc: "Tournament configuration & virtual divisions" },
    { to: "/admin/overpass-usage", title: "OverPass Usage", desc: "PowerHuds OverPass proxy usage per user — block abusers" },
    { to: "/admin/api-keys", title: "API Keys", desc: "Issue & revoke public API keys — monitor caster/streamer usage" },
    { to: "/admin/unsigned-graphics", title: "Unsigned Graphics", desc: "Weekly schedule cards + X captions for the Unsigned teams" },
    { to: "/admin/recompute", title: "Rating 3.0 recompute", desc: "Re-rate parsed maps with the v3 model in the background, then apply" },
];

const tileStyle: React.CSSProperties = {
    display: "block",
    background: "linear-gradient(135deg, rgba(26,26,26,0.95) 0%, rgba(37,37,37,0.95) 100%)",
    border: "1px solid rgba(255,102,0,0.15)",
    borderRadius: 12,
    padding: "20px 22px",
    textDecoration: "none",
    color: "var(--text-primary, #e2e8f0)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
    transition: "transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease",
};

const AdminHubPage: React.FC = () => {
    const { user, authLoaded } = useContext(AuthContext);
    const isAdmin = !!user && admins.includes(user.steamID);

    if (authLoaded && !isAdmin) {
        return <div className="container mt-4"><div className="alert alert-danger">Admins only.</div></div>;
    }

    return (
        <div className="container mt-4">
            <h3 className="mb-1">Admin</h3>
            <p style={{ color: "rgba(255,255,255,0.6)" }}>Site administration tools.</p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 16, marginTop: 16 }}>
                {tiles.map(t => (
                    <Link
                        key={t.to}
                        to={t.to}
                        style={tileStyle}
                        onMouseOver={e => { (e.currentTarget as HTMLElement).style.transform = "translateY(-2px)"; (e.currentTarget as HTMLElement).style.borderColor = "rgba(255,102,0,0.4)"; }}
                        onMouseOut={e => { (e.currentTarget as HTMLElement).style.transform = "none"; (e.currentTarget as HTMLElement).style.borderColor = "rgba(255,102,0,0.15)"; }}
                    >
                        <div style={{ fontWeight: 700, fontSize: "1.1rem", marginBottom: 6 }}>{t.title}</div>
                        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.85rem" }}>{t.desc}</div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default AdminHubPage;
